export default "__VITE_ASSET__f4277311__"